export default {
	alert: {
		plural: '{alertCount} alerts',
		singular: '{alertCount} alert',
	},
	success: 'All clear',
};
